import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type AdminAddFormType = {
  adminId?: string;
  email?: string;
  userName?: string;
  password?: string;
  confPassword?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  address?: string;
  state?: string;
  country?: string;
  countryId?: string;
};

export const AdminAddFormSchema = Model({
  email: Types.StringType().isRequired("Email is required"),
  userName: Types.StringType().isRequired("UserName is required"),
  password: Types.StringType().isRequired("Password is required"),
  confPassword: Types.StringType().isRequired("Please confirm your password"),
  firstName: Types.StringType().isRequired("First name is required"),
  lastName: Types.StringType().isRequired("Last name is required"),
  companyName: Types.StringType().isRequired("Company name is required"),
  address: Types.StringType().isRequired("Address is required"),
  state: Types.StringType().isRequired("State is required"),
  countryId: Types.StringType().isRequired("Country is required"),
});

export const AdminAddDefaultValues: AdminAddFormType = {
  adminId: "",
  email: "",
  userName: "",
  password: "",
  confPassword: "",
  firstName: "",
  lastName: "",
  companyName: "",
  address: "",
  state: "",
  countryId: "",
};
